import { useMemo, useState } from "react";
import { Country, State, City } from "country-state-city";
import SearchableDropdown from "./SearchDropdown";

const CountryStateCityDropdown = ({ country, state, city, onSelectHandler, showCountry = false, countryErr, stateErr, cityErr }) => {
    const [countryCode, setCountryCode] = useState("");
    const [stateCode, setStatecode] = useState("");

    const countryOptions = useMemo(() => {
        return Country.getAllCountries().map((c) => ({
            name: c.name,
            id: c.isoCode
        }));
    }, []);

    const stateOptions = useMemo(() => {
        let code = countryCode;
        if (!country) return [];
        if(country && !code) {
            code = countryOptions.find(item => item.name == country)?.id || "";
            setCountryCode(code);
        }
        if(!code) return [];
        return State.getStatesOfCountry(code).map((s) => ({
            name: s.name,
            id: s.isoCode
        }));
    }, [country, countryCode]);

    const cityOptions = useMemo(() => {
        let code = stateCode;
        if (!countryCode && !stateCode) return [];
        if(!countryCode) return [];
        if(countryCode && state && !stateCode) code = stateOptions.find(item => item.name == state)?.id || null;
        if(!code) return [];
        return City.getCitiesOfState(countryCode, code).map((ci) => ({
            name: ci.name,
            id: ci.name
        }));
    }, [country, countryCode, state, stateCode]);

    const handleCountryChange = (selectedCountry) => {
        setCountryCode(selectedCountry?.id ?? "");
        setTimeout(() => {
            onSelectHandler({ country: selectedCountry?.name ?? "", state: "", city: "" })
        }, 100)
    };

    const handleStateChange = (selectedState) => {
        setStatecode(selectedState?.id ?? "");
        onSelectHandler({ country, state: selectedState?.name ?? "", city: null })
    };

    const handleCityChange = (selectedCity) => {
        onSelectHandler({ country, state, city: selectedCity?.name ?? "" });
    };

    return (
        <>
            {showCountry ? <div className="col-lg-4 col-md-6 mb-2">
                <SearchableDropdown
                    label={"Select Country"}
                    placeholder={"Select Country"}
                    value={country}
                    error={countryErr}
                    isRequired={false}
                    options={countryOptions}
                    onSelect={handleCountryChange}
                    disabled={!showCountry}
                />
            </div> : null}
            <div className={`col-lg-${showCountry ? "4" : "6"} col-md-6 mb-2`}>
                <SearchableDropdown
                    label={"Select State"}
                    placeholder={"Select State"}
                    value={state}
                    isRequired={false}
                    error={stateErr}
                    options={stateOptions}
                    onSelect={handleStateChange}
                    disabled={!country}
                />
            </div>
            <div className={`col-lg-${showCountry ? "4" : "6"} col-md-6 mb-2`} key={state}>
            <SearchableDropdown
                    label={"Select City"}
                    placeholder={"Select City"}
                    value={city}
                    error={cityErr}
                    isRequired={false}
                    options={cityOptions}
                    onSelect={handleCityChange}
                    disabled={!state}
                />
            </div>
        </>
    );
};

export default CountryStateCityDropdown;